import script from "./TextInputController.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInputController.vue?vue&type=script&setup=true&lang=js"

import "./TextInputController.vue?vue&type=style&index=0&id=57d369fd&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d369fd"]])

export default __exports__